import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'umkt-external-channel-exit-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './external-channel-exit-modal.component.html',
  styleUrl: './external-channel-exit-modal.component.scss',
})
export class ExternalChannelExitModalComponent {
  @Input() open = false;

  @Output() exit = new EventEmitter<void>();
  @Output() stay = new EventEmitter<void>();

  onStay(): void {
    this.stay.emit();
  }

  onExit(): void {
    this.exit.emit();
  }
}
